import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogujratcab() {



    const cardData = {





keyword: "Mumbai to Gujarat Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Mumbai to Gujarat Cab Service for family trips, business travel, corporate transportation, pilgrimage tours, weekend getaways, one-way journeys, round trips, and long-distance travel. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a safe and convenient journey from Mumbai to different destinations across Gujarat. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup, flexible booking options, and 24/7 customer support, we ensure a smooth and hassle-free travel experience. Whether you are traveling for tourism, religious visits, business meetings, or family occasions, Shreesha Tours & Travels provides dependable Mumbai to Gujarat cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Ahmedabad",
    description: "Ahmedabad is Gujarat's largest city known for Sabarmati Ashram, Adalaj Stepwell, Kankaria Lake, heritage sites, and vibrant culture. It is a popular destination for business and leisure travelers."
  },
  {
    title: "Vadodara",
    description: "Vadodara is famous for Laxmi Vilas Palace, Sayaji Garden, museums, and royal heritage. It is an important cultural and business city of Gujarat."
  },
  {
    title: "Surat",
    description: "Surat is known as the Diamond City of India, famous for textile markets, Dumas Beach, Surat Castle, and delicious Gujarati cuisine. It is a major business destination."
  },
  {
    title: "Dwarka",
    description: "Dwarka is a sacred pilgrimage destination famous for Dwarkadhish Temple, coastal beauty, and spiritual importance as one of India's Char Dham sites."
  },
  {
    title: "Somnath",
    description: "Somnath is one of the twelve Jyotirlingas of Lord Shiva and a famous religious destination known for Somnath Temple and beautiful Arabian Sea views."
  },
  {
    title: "Statue of Unity",
    description: "Statue of Unity is the world's tallest statue and a major tourist attraction near Kevadia, featuring museums, viewing galleries, gardens, and adventure activities."
  },
  {
    title: "Gir National Park",
    description: "Gir National Park is famous as the home of Asiatic lions and offers wildlife safari experiences, nature trails, and unique biodiversity."
  },
  {
    title: "Saputara",
    description: "Saputara is Gujarat's popular hill station known for lakes, viewpoints, waterfalls, ropeway rides, and peaceful natural surroundings."
  },
  {
    title: "Daman",
    description: "Daman is a coastal destination near Gujarat known for beaches, forts, churches, and relaxing seaside attractions. It is a popular weekend getaway from Mumbai."
  },
  {
    title: "Rann of Kutch",
    description: "Rann of Kutch is famous for its white salt desert, Rann Utsav, cultural festivals, handicrafts, and breathtaking landscapes. It is one of Gujarat's most unique travel destinations."
  }
],


"services": [
  {
    "name": "Mumbai to Gujarat Cab",
    "description": "Book Mumbai to Gujarat Cab for safe, comfortable, and reliable interstate travel with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth journey from Mumbai to Gujarat with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family trips, business travel, Gujarat tours, and long-distance transportation."
  },
  {
    "name": "Mumbai to Gujarat Taxi",
    "description": "Choose Mumbai to Gujarat Taxi for convenient and affordable road travel with experienced drivers and comfortable vehicles. Get doorstep pickup, clean AC cars, transparent pricing, and reliable taxi service for personal, corporate, and tourist journeys across Gujarat."
  },
  {
    "name": "Mumbai to Gujarat Cab Service",
    "description": "Book Mumbai to Gujarat Cab Service for dependable interstate transportation with trained chauffeurs and premium vehicles. Our cab services provide comfortable travel solutions for family vacations, business trips, religious tours, and Gujarat sightseeing journeys."
  },
  {
    "name": "Mumbai to Gujarat Taxi Service",
    "description": "Hire Mumbai to Gujarat Taxi Service for smooth highway travel with professional drivers and well-maintained cars. Enjoy flexible booking options, comfortable seating, affordable fares, and reliable taxi facilities for your Gujarat journey."
  },
  {
    "name": "Mumbai to Gujarat Cab Booking",
    "description": "Complete Mumbai to Gujarat Cab Booking with easy reservations, quick confirmation, and multiple vehicle options. Select Sedan, SUV, Ertiga, Innova, Innova Crysta, or premium cars according to your travel requirements and group size."
  },
  {
    "name": "Mumbai to Gujarat Car Rental",
    "description": "Choose Mumbai to Gujarat Car Rental for chauffeur-driven vehicles designed for comfortable interstate travel. Enjoy spacious cars, professional drivers, flexible schedules, and affordable rental packages for business trips, family tours, and Gujarat exploration."
  },
  {
    "name": "Mumbai to Gujarat Outstation Cab",
    "description": "Book Mumbai to Gujarat Outstation Cab for safe and reliable long-distance transportation with premium vehicles and experienced chauffeurs. Perfect for interstate journeys, family trips, corporate travel, and Gujarat tour packages."
  },
  {
    "name": "Mumbai to Gujarat One Way Taxi",
    "description": "Reserve Mumbai to Gujarat One Way Taxi for convenient drop taxi service without return fare charges. Travel comfortably with skilled drivers, clean vehicles, and flexible pickup locations from Mumbai to different Gujarat destinations."
  },
  {
    "name": "Mumbai to Gujarat Round Trip Cab",
    "description": "Choose Mumbai to Gujarat Round Trip Cab for complete return travel with flexible timings and comfortable vehicles. Ideal for Gujarat vacations, family visits, business trips, sightseeing tours, and extended stays."
  },
  {
    "name": "Mumbai Airport to Gujarat Cab",
    "description": "Book Mumbai Airport to Gujarat Cab for smooth airport transfer and direct interstate travel. Enjoy timely pickup, luggage-friendly vehicles, professional chauffeurs, and comfortable transportation from Mumbai Airport to Gujarat cities."
  },
  {
    "name": "Mumbai to Gujarat Private Taxi",
    "description": "Hire Mumbai to Gujarat Private Taxi for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, flexible routes, comfortable seating, and a peaceful journey for business or personal transportation."
  },
  {
    "name": "Mumbai to Gujarat Innova Cab",
    "description": "Choose Mumbai to Gujarat Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Perfect for families and groups planning a relaxing interstate journey with complete comfort."
  },
  {
    "name": "Mumbai to Gujarat Ertiga Cab",
    "description": "Reserve Mumbai to Gujarat Ertiga Cab for affordable group transportation with comfortable interiors and reliable performance. Suitable for families and small groups looking for economical and convenient long-distance travel."
  },
  {
    "name": "Mumbai Gujarat Tour Package by Cab",
    "description": "Book Mumbai Gujarat Tour Package by Cab for a comfortable and customized travel experience across Gujarat destinations. Enjoy professional drivers, premium vehicles, flexible itineraries, and convenient sightseeing options for family and group tours."
  },
  {
    "name": "Best Mumbai Gujarat Cab Service",
    "description": "Choose the Best Mumbai Gujarat Cab Service for safe, comfortable, and reliable interstate travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, transparent pricing, and dependable cab services for family trips, corporate journeys, Gujarat tours, and long-distance travel from Mumbai."
  }
],
"tableData": [
  ["Mumbai to Gujarat Cab", "Mumbai to Gujarat Taxi"],
  ["Mumbai to Gujarat Cab Service", "Mumbai to Gujarat Taxi Service"],
  ["Mumbai to Gujarat Cab Booking", "Mumbai to Gujarat Car Rental"],
  ["Mumbai to Gujarat Outstation Cab", "Mumbai to Gujarat One Way Taxi"],
  ["Mumbai to Gujarat Round Trip Cab", "Mumbai Airport to Gujarat Cab"],
  ["Mumbai to Gujarat Private Taxi", "Mumbai to Gujarat Innova Cab"],
  ["Mumbai to Gujarat Ertiga Cab", "Mumbai Gujarat Tour Package by Cab"],
  ["Best Mumbai Gujarat Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Gujarat Cab Service",
    WhyChoosedescription: "Shreesha Travels provides comfortable Mumbai to Gujarat cab services for families, business travellers, tourists, and personal journeys. Travel across Gujarat with experienced chauffeurs, well-maintained vehicles, and flexible travel options."
  },
  {
    WhyChooseheading: "Convenient Travel to Gujarat Destinations",
    WhyChoosedescription: "Enjoy smooth connectivity from Mumbai to Ahmedabad, Surat, Vadodara, Rajkot, Dwarka, Somnath, Gandhinagar, Bhuj, and other Gujarat destinations with private cab facilities."
  },
  {
    WhyChooseheading: "Multiple Cars Available for Every Group",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles according to your travel requirements."
  },
  {
    WhyChooseheading: "Ideal for Family Tours & Business Travel",
    WhyChoosedescription: "Our Mumbai to Gujarat taxis are suitable for family vacations, religious tours, corporate visits, industrial travel, wedding transportation, and customized Gujarat sightseeing trips."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "Select a one-way cab for direct travel to Gujarat or choose a round-trip package with flexible return schedules, waiting options, and personalized travel plans."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Mumbai-Gujarat highway routes and ensure safe driving, timely service, and a comfortable journey throughout the trip."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Long Distance Travel",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before departure to provide a reliable and pleasant interstate travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Gujarat Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking assistance, comfortable vehicles, and dependable chauffeur-driven cab services for your Mumbai to Gujarat journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Gujarat cab for any city?",
    answer: "Yes, we provide cab services from Mumbai to major Gujarat cities including Ahmedabad, Surat, Vadodara, Rajkot, Gandhinagar, Dwarka, Somnath, and other locations."
  },
  {
    question: "Is Mumbai to Gujarat one-way cab service available?",
    answer: "Yes, one-way taxi booking is available for passengers travelling directly from Mumbai to Gujarat destinations."
  },
  {
    question: "Which vehicles are available for Mumbai to Gujarat travel?",
    answer: "We offer Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Gujarat?",
    answer: "Yes, round-trip cab packages are available with flexible return dates and customized travel schedules."
  },
  {
    question: "Are Mumbai to Gujarat cabs suitable for family tours?",
    answer: "Yes, comfortable vehicles and professional drivers make long-distance family travel convenient and enjoyable."
  },
  {
    question: "Can I customize my Gujarat travel itinerary?",
    answer: "Yes, you can customize routes with sightseeing stops, religious places, and multiple Gujarat destinations according to your plan."
  },
  {
    question: "Do you provide corporate cab services from Mumbai to Gujarat?",
    answer: "Yes, our services support business meetings, industrial visits, employee travel, and corporate transportation requirements."
  },
  {
    question: "How is the Mumbai to Gujarat cab fare calculated?",
    answer: "The fare depends on vehicle category, travel distance, trip duration, route, driver charges, and additional requirements."
  },
  {
    question: "Are overnight journeys available from Mumbai to Gujarat?",
    answer: "Yes, overnight travel options are available with experienced drivers for comfortable interstate journeys."
  },
  {
    question: "How can I book Mumbai to Gujarat Cab with Shreesha Travels?",
    answer: "Share your pickup location, destination city, travel date, passenger details, and preferred vehicle to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Patel",
    feedback: "The Mumbai to Gujarat cab service was excellent. The vehicle was comfortable, the driver was professional, and the complete journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rina Shah",
    feedback: "We booked a family trip from Mumbai to Gujarat and had a great experience. The clean car and reliable service made our journey comfortable.",
    rating: 5
  }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Gujarat Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-gujarat-cab.webp",
  "description":
    "Book Mumbai to Gujarat Cab with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for family trips, business travel, sightseeing tours, one-way, round-trip, and long-distance journeys from Mumbai to Gujarat with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-gujarat-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Mumbai to Gujarat Cab | Outstation Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Gujarat Cab with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way, round-trip, family trips, business travel, and long-distance journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Gujarat Cab, Mumbai to Gujarat Taxi, Mumbai to Gujarat Cab Service, Mumbai to Gujarat Taxi Service, Mumbai to Gujarat Cab Booking, Mumbai to Gujarat Car Rental, Mumbai to Gujarat Outstation Cab, Mumbai to Gujarat One Way Taxi, Mumbai to Gujarat Round Trip Cab, Mumbai Gujarat Taxi Booking, Gujarat Tour Cab from Mumbai, Mumbai Gujarat Car Hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogujratcab;